"use client";

import { useEffect, useRef, useState } from "react";
import CommonImage from "../../image/CommonImage";
import Link from "next/link";
import UserService from "@/services/api/UserService";
import { useSelector } from "react-redux";
import { useRouter } from "next/navigation";

export default function StudentNotifications({ isOpen, toggleMenu }) {
  const userInfo = useSelector((state) => state.user.userInfo);
  const router = useRouter();
  const menuRef = useRef(null);
  const listRef = useRef(null);

  const [notifications, setNotifications] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        toggleMenu(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, toggleMenu]);

  useEffect(() => {
    if (isOpen && notifications.length === 0) {
      fetchNotifications(page);
    }
  }, [isOpen]);

  useEffect(() => {
    const handleScroll = () => {
      if (!listRef.current || loading || !hasMore) return;

      const { scrollTop, scrollHeight, clientHeight } = listRef.current;

      if (scrollTop + clientHeight >= scrollHeight - 50) {
        fetchNotifications(page + 1);
      }
    };

    const listEl = listRef.current;
    if (listEl) {
      listEl.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (listEl) {
        listEl.removeEventListener("scroll", handleScroll);
      }
    };
  }, [page, loading, hasMore]);

  const fetchNotifications = async (nextPage) => {
    setLoading(true);
    try {
      const res = await UserService.getNotifications({
        page: nextPage,
      });

      if (res?.data?.length) {
        setNotifications((prev) => [...prev, ...res.data]);
        setPage(nextPage);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Notification fetch failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleNotificationClick = async (item) => {
    try {
      await UserService.markNotificationAsRead(item.id);
      fetchNotifications();

      const type = item?.notification?.notification_for;

      switch (type) {
        case "Exam":
        case "Class":
          router.push("/student/my-courses");
          break;
        case "Payment":
          router.push("/student/payment-history");
          break;
        case "Admission":
          router.push("/student/my-courses");
          break;
        case "Notice":
          router.push("/notice");
          break;
        case "Result":
          router.push("/student/result");
          break;
        default:
          console.log("Unknown notification type:", type);
          break;
      }
    } catch (error) {
      console.error("Failed to mark as read:", error);
    }
  };

  return (
    <div ref={menuRef} className="relative flex items-center">
      <button onClick={toggleMenu} className="notification cursor-pointer">
        <CommonImage
          src={"/images/student-dashboard/bell-icon.avif"}
          className="notification-icon flex items-center"
          alt={"notifaction"}
        />
        <span className="total-notification">
          {userInfo?.notifications ?? 0}
        </span>
      </button>

      {isOpen && (
        <div
          className="notification-dropdown-menu"
          ref={listRef}
          style={{ maxHeight: "300px", overflowY: "auto" }}
        >
          {notifications.length > 0 ? (
            notifications.map((item) => (
              <a
                key={item.id}
                onClick={() => handleNotificationClick(item)}
                className={
                  item.is_seen
                    ? "single-notification-read"
                    : "single-notification-unread"
                }
              >
                {!item.is_seen && (
                  <div className="unread-icon">
                    <span className="icon"></span>
                  </div>
                )}
                <div className="empty">
                  <div className="notification-icon-wrap">
                    <CommonImage
                      src={"/images/student-dashboard/notification-bell.avif"}
                      className="notification-icon"
                      alt={"notifaction"}
                    />
                  </div>
                </div>
                <div className="noticication-text">
                  <p className="text">{item?.notification?.message}</p>
                  <p className="date">{item?.notification?.date}</p>
                </div>
              </a>
            ))
          ) : (
            <div
              style={{
                padding: 20,
                textAlign: "center",
                color: "gray",
              }}
            >
              কোনো নোটিফিকেশন পাওয়া যায়নি
            </div>
          )}

          {loading && (
            <div
              style={{ padding: 10, textAlign: "center" }}
              className="text-primary-text-3"
            >
              লোড হচ্ছে...
            </div>
          )}
        </div>
      )}
    </div>
  );
}
